import MaterialTreeView from '@material-ui/lab/TreeView';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Icon } from '../../icons';
import TreeItem from './TreeItem';
import { TreeItemExact } from '../../../models/TreeItem';

const TreeView = ({ items, expandIcon, collapseIcon, expandedItems, initialToggleActions, ...materialProps }) => {
  const [toggleActions, setToggleActions] = useState(initialToggleActions);

  const handleActionToggle = useCallback(() => {
    setToggleActions(undefined);
  }, []);

  return (
    <MaterialTreeView
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...materialProps}
      defaultExpandIcon={expandIcon || <Icon icon="chevron_right" />}
      defaultCollapseIcon={collapseIcon || <Icon icon="expand_more" />}
      defaultExpanded={expandedItems}>
      {items && items.map((item) => <TreeItem key={item.id} item={item} parentToggledActions={toggleActions} onActionToggle={handleActionToggle} />)}
    </MaterialTreeView>
  );
};

TreeView.propTypes = {
  collapseIcon: PropTypes.node,
  expandIcon: PropTypes.node,
  expandedItems: PropTypes.arrayOf(PropTypes.shape()),
  initialToggleActions: PropTypes.objectOf(PropTypes.bool),
  items: PropTypes.arrayOf(TreeItemExact),
};

TreeView.defaultProps = {
  collapseIcon: undefined,
  expandIcon: undefined,
  expandedItems: [],
  initialToggleActions: undefined,
  items: [],
};

export default React.memo(TreeView);
